function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import pathOr from 'ramda/src/pathOr';
import pluck from 'ramda/src/pluck';
import uniqBy from 'ramda/src/uniqBy';
import { createSelector } from 'reselect';
import Immutable from 'seamless-immutable';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { OfferingMetadataPricingPlansSelector } from 'invision-core/src/components/metadata/offerings/offerings.selectors';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { RouteParams, SelectedCustomerSelector } from './customer.selectors';
import { GENERAL_STATUSES } from '../../components/shared/constants/general.status.constants';
import { PRICING_PLAN_SERVICE_RELATIONSHIP_TYPE } from '../../customercare.constants';
import { AccountOfferingsSelector } from './dashboard.selectors';
import { GetOfferingOrderQuoteSelector } from '../helpers/offer.ordering.wizard.selector.helper';
import { OfferingOrderQuoteSelector } from './offering.order.selectors';
import { ContractInstanceSelector } from './contract.selectors';
var EMPTY_ARRAY = Immutable([]);
var EMPTY_OBJECT = Immutable({});
export var OfferingDisconnectSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.disconnectOffering;
});
export var RemoveOfferItemsIdsSelector = createSelector([RouteParams], function (routeParams) {
  return routeParams.offeringId && routeParams.offeringInstanceId ? [{
    offeringId: routeParams.offeringId,
    offeringInstanceId: routeParams.offeringInstanceId
  }] : null;
});
export var IsFullDisconnect = createSelector([RemoveOfferItemsIdsSelector], function (removeOfferingId) {
  return removeOfferingId === null;
});
var DisconnectData = createSelector([OfferingDisconnectSelector], function (offeringDisconnect) {
  return offeringDisconnect.data;
});
var EtfData = createSelector([DisconnectData], function (disconnectData) {
  return disconnectData.etfWaive;
});
export var BillingEffectiveDateConfigurationSelector = createImmutableSelector([DisconnectData], function (disconnectData) {
  return disconnectData.billingEffectiveDateConfiguration || EMPTY_OBJECT;
});
export var BillingEffectiveDateSettingsSelector = createImmutableSelector([BillingEffectiveDateConfigurationSelector], function (billingEffectiveDateConfiguration) {
  return {
    minimumDate: billingEffectiveDateConfiguration.MinBillingEffectiveDate,
    pastDateMaxLength: billingEffectiveDateConfiguration.PastBillingEffectiveDateMaxLength
  };
});
export var BillingEffectiveDateOptionsSelector = createImmutableSelector([BillingEffectiveDateConfigurationSelector], function (billingEffectiveDateConfiguration) {
  return billingEffectiveDateConfiguration.OrderExecutionToBillingEffectiveDateIntentions || EMPTY_ARRAY;
});
export var IsEtfWaived = createSelector([EtfData], function (etfData) {
  return etfData.waive;
});
export var EtfWaiveReason = createSelector([EtfData], function (etfData) {
  return etfData.waiveReason;
});
export var IsRetrievingContextSelector = createSelector([OfferingDisconnectSelector], function (offeringDisconnect) {
  return offeringDisconnect.isRetrievingContext;
});
export var IsDisconnectQuoteBypassedSelector = createSelector([OfferingDisconnectSelector], function (offeringDisconnect) {
  return offeringDisconnect.isQuoteBypassed;
});
export var IsSubmittingOrderSelector = createSelector([OfferingDisconnectSelector], function (offeringDisconnect) {
  return offeringDisconnect.isSubmittingOrder;
});
var RemoveItems = createSelector([DisconnectData], function (disconnectData) {
  return disconnectData.removeItems;
});
export var DisconnectItemsSelector = createSelector([RemoveItems, IsEtfWaived, EtfWaiveReason], function (removeItems, isEtfWaive, etfWaiveReaason) {
  return removeItems.map(function (item) {
    return isEtfWaive ? Object.assign({}, item, {
      OrderContractInstance: Object.assign({}, item.OrderContractInstance, {
        EarlyTerminationFeeOverrideReason: etfWaiveReaason,
        IsEarlyTerminationFeeOverride: isEtfWaive
      })
    }) : item;
  });
});
export var HasFinancedDevicesSelector = createImmutableSelector([DisconnectItemsSelector], function (disconnectItems) {
  return disconnectItems.some(function (disconnectItem) {
    return disconnectItem.FinanceDetails;
  });
});
export var HasProvidesPlansSelector = createImmutableSelector([RemoveItems, OfferingMetadataPricingPlansSelector], function (removeItems, pricingPlanThumbnails) {
  return removeItems.some(function (removeItem) {
    return pricingPlanThumbnails[removeItem.PricingPlanId] && pricingPlanThumbnails[removeItem.PricingPlanId].ServiceRelationshipType === PRICING_PLAN_SERVICE_RELATIONSHIP_TYPE.PROVIDES;
  });
});
export var DisconnectQuoteSelector = createSelector([IsFullDisconnect, DisconnectData, GetOfferingOrderQuoteSelector([OfferingOrderQuoteSelector])], function (isFullDisconnect, disconnectData, offeringOrderQuote) {
  return isFullDisconnect ? disconnectData.quote : offeringOrderQuote;
});
export var IsCalculatingQuoteSelector = createSelector([OfferingDisconnectSelector], function (disconnectOffering) {
  return disconnectOffering.isCalculatingQuote;
});
export var ContractIdRouteParamSelector = createSelector([RouteParams], function (routeParams) {
  return routeParams.contractId;
});
var QuoteItems = createSelector(DisconnectQuoteSelector, function (quote) {
  return pathOr(EMPTY_ARRAY, ['Items'], quote);
});
export var DisconnectOfferServiceFeaturesSelector = createSelector(DisconnectQuoteSelector, function (quote) {
  return pathOr(EMPTY_ARRAY, ['Items'], quote).filter(function (quoteItem) {
    return quoteItem.Product.ProductClassification === PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE && quoteItem.Product.Status === GENERAL_STATUSES.ACTIVE;
  }).map(function (feature) {
    return {
      Amount: feature.Amount,
      Currency: quote.Currency,
      ProductName: feature.Name,
      Quantity: feature.Quantity,
      SubscriberProductId: feature.SubscriberProductId
    };
  });
});
export var DefaultEtfAmount = createSelector([EtfData], function (etfData) {
  return etfData.defaultAmount;
});
export var DisconnectOrderContractInstanceSelector = createImmutableSelector([EtfWaiveReason, OfferingOrderQuoteSelector, ContractInstanceSelector], function (etfWaiveReason, offeringOrderQuote, contractInstance) {
  if (offeringOrderQuote.OfferingQuotes && offeringOrderQuote.OfferingQuotes.length) {
    var quoteItemWithContractInstance = offeringOrderQuote.OfferingQuotes.find(function (offeringQuote) {
      return !!offeringQuote.OrderContractInstanceId;
    });
    return quoteItemWithContractInstance ? Object.assign({}, {
      orderContractInstanceId: quoteItemWithContractInstance.OrderContractInstanceId,
      contractName: contractInstance ? contractInstance.ContractName : null,
      contractId: contractInstance ? contractInstance.OrderContractId : null,
      currency: offeringOrderQuote.Currency,
      isETFOverride: contractInstance ? contractInstance.IsEarlyTerminationFeeOverride : null,
      earlyTerminationFeeOverrideReason: contractInstance && contractInstance.EarlyTerminationFeeOverrideReason ? contractInstance.EarlyTerminationFeeOverrideReason : null
    }) : EMPTY_OBJECT;
  }
  return EMPTY_OBJECT;
});
export var DisconnectAdhocQuoteItemsSelector = createSelector([QuoteItems], function (quoteItems) {
  if (quoteItems.length) {
    var adhocsQuoteItems = quoteItems.filter(function (quoteItem) {
      return quoteItem.Product.ProductClassification === PRODUCT_CLASSIFICATIONS.AD_HOC;
    });
    return adhocsQuoteItems.map(function (adhocItem) {
      return {
        productName: adhocItem.Name,
        amount: adhocItem.Amount,
        currency: adhocItem.PricingPlan.Currency,
        quantity: adhocItem.Quantity,
        connectedDate: adhocItem.ConnectedDate
      };
    });
  } else {
    return EMPTY_ARRAY;
  }
});
export var HasDisconnectAdhocsSelector = createSelector([DisconnectAdhocQuoteItemsSelector], function (disconnectAdhocQuoteItems) {
  return !!disconnectAdhocQuoteItems.length;
});

// TODO: A Pricing Plan can have more than 1 BulkChargeTypeCode, this is to be resolved in PD-665742
var getBulkChargeType = function getBulkChargeType(pricingPlan) {
  var bulkableBris = [].concat(_toConsumableArray(pricingPlan.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances), _toConsumableArray(pricingPlan.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances));
  var bulkBris = bulkableBris.filter(function (bri) {
    return bri.BulkChargeTypeCode;
  });
  return bulkBris && bulkBris.length ? uniqBy(Math.abs, pluck('BulkChargeTypeCode', bulkBris)) : EMPTY_ARRAY;
};
export var OfferGroupedQuoteItems = createSelector([QuoteItems, OfferingMetadataPricingPlansSelector, IsDbss], function (quoteItems, pricingPlanMetadata, isDbss) {
  var offerQuoteItems = quoteItems.filter(function (quoteItem) {
    return quoteItem.Product.ProductClassification !== PRODUCT_CLASSIFICATIONS.AD_HOC && quoteItem.Product.ProductClassification !== PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE;
  });
  if (offerQuoteItems.length) {
    var offerGroupedItems = {};
    offerQuoteItems.forEach(function (item) {
      var bulkChargeTypeCodes = [];
      if (isDbss) {
        var metadata = pricingPlanMetadata[item.PricingPlan.Id];
        if (metadata) {
          bulkChargeTypeCodes = getBulkChargeType(pricingPlanMetadata[item.PricingPlan.Id]);
        }
      }
      if (!offerGroupedItems[item.OfferingInstanceId]) {
        offerGroupedItems[item.OfferingInstanceId] = {
          items: [],
          orderedOfferingName: item.OrderedOfferingName
        };
      }
      offerGroupedItems[item.OfferingInstanceId].items.push(Object.assign({}, item, {
        bulk: !!bulkChargeTypeCodes.length,
        bulkChargeTypeCodes: bulkChargeTypeCodes
      }));
    });
    return offerGroupedItems;
  } else {
    return EMPTY_OBJECT;
  }
});
export var DisconnectOfferingServiceIdentifiersSelector = createImmutableSelector([RouteParams, AccountOfferingsSelector], function (routeParams, accountOfferings) {
  var disconnetingOffer = accountOfferings.find(function (offer) {
    return routeParams.offeringInstanceId === offer.OfferingInstanceId;
  });
  return disconnetingOffer ? disconnetingOffer.serviceIdentifiers : EMPTY_ARRAY;
});
export var QuoteHasInvoiceItemsSelector = createImmutableSelector([DisconnectQuoteSelector], function (quote) {
  return quote.HasInvoiceItems;
});